import { render, staticRenderFns } from "./CallBackSection.vue?vue&type=template&id=2c7104fe&"
import script from "./CallBackSection.vue?vue&type=script&lang=js&"
export * from "./CallBackSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports